import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./components/common/Navbar";
import Footer from "./components/common/Footer";
import Chatbot from "./components/chatbot/Chatbot";
import HomePage from "./pages/HomePage";
import PropertiesPage from "./pages/PropertiesPage";
import PropertyDetailPage from "./pages/PropertyDetailPage";
import ContactPage from "./pages/ContactPage";
import DevelopersPage from "./pages/DevelopersPage";
import BuilderPage from "./pages/BuilderPage";
import AboutPage from "./pages/AboutPage";
import WhyGroupBuyPage from "./pages/WhyGroupBuyPage";
import WhyDeveloperChooseUs from "./pages/WhyDeveloperChooseUs";
import FaqPage from "./pages/FaqPage";
import ServicesPage from "./pages/ServicesPage";
import CareersPage from "./pages/CareersPage";
import AdminPage from "./pages/AdminPage";

// Create ScrollToTop component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <Router>
      <ScrollToTop /> {/* Add this here */}
      <div style={{ background: "#F2F8F3", minHeight: "100vh", display: "flex", flexDirection: "column" }}>
        <Navbar />
        <main style={{ flex: 1 }}>
          <Routes>
            {/* Default redirect to /tg (Telangana) */}
            <Route path="/" element={<Navigate to="/tg" replace />} />
            {/* State-based routes */}
            <Route path="/tg" element={<HomePage stateCode="tg" stateName="Telangana" />} />
            <Route path="/ka" element={<HomePage stateCode="ka" stateName="Karnataka" />} />
            <Route path="/properties" element={<PropertiesPage />} />
            <Route path="/developers" element={<DevelopersPage />} />
            <Route path="/builder/:slug" element={<BuilderPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/why-groupbuy" element={<WhyGroupBuyPage />} />
            <Route path="/why-developers" element={<WhyDeveloperChooseUs />} />
            <Route path="/faqs" element={<FaqPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/property/:id" element={<PropertyDetailPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="*" element={
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "60vh", color: "#013220", gap: "16px", paddingTop: "68px" }}>
                <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "2rem", color: "rgba(1,50,32,0.62)" }}>Page not found</p>
                <a href="/tg" style={{ color: "#50C878", fontFamily: "'Inter', sans-serif" }}>Go home →</a>
              </div>
            } />
          </Routes>
        </main>
        <Footer />
        <Chatbot />
      </div>
    </Router>
  );
}